export function stringToNum(string) {
  return parseInt(string, 10);
}

export function checkIfParamString(param) {
  return typeof param === 'string';
}

export function checkForQueryKey(obj, key) {
  return key in obj;
}

export function isParamToAdjust(obj, key) {
  return checkForQueryKey(obj, key) &&
    checkIfParamString(obj[key]);
}

export function queryParamToArray(param) {
  if (Array.isArray(param)) return param;
  return [param];
}

export function stringsToInts(param = '') {
  if (!Array.isArray(param)) return stringToNum(param);
  return param.map((p) => {
    if (typeof p === 'string') return stringToNum(p);
    return p;
  });
}

export function queryParamStringsToIntArray(param) {
  return stringsToInts(queryParamToArray(param));
}

export function reassignQueryProps(query, keys, newVals) {
  const newQuery = Object.assign({}, query);
  keys.forEach((k, i) => {
    newQuery[k] = newVals[i];
  });
  return newQuery;
}



// WEBPACK FOOTER //
// ./client/app/utils/validationUtils.js